<template>
  <div>
    <ApplyPC v-if="!isMobile()"></ApplyPC>
    <ApplyMOBILE v-else></ApplyMOBILE>
  </div>
</template>

<script>
import ApplyPC from './ApplyPC.vue'
import ApplyMOBILE from './ApplyMOBILE.vue'
export default {
  components: {
    ApplyPC,
    ApplyMOBILE
  },
  methods: {
    isMobile () {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera

      // 常见的移动设备用户代理字符串特征
      // 注意：这个列表可能不完整，因为新的设备和浏览器会不断出现
      const mobileRegex =
        /android|iphone|ipad|ipod|blackberry|windows phone|iemobile|opera mini/i

      // 如果用户代理字符串包含上述任一特征，则认为是移动设备
      return mobileRegex.test(userAgent)
    }
  }
}
</script>

<style>

</style>
